import { http } from "./api";

export const serviceTypeBusiness = {
    // Obtener todos los tipos de negocio
    getAll: async () => {
        try {
            const response = await http.get("/v1/type-businesses/select-options");

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                    message: "Tipos de negocio obtenidos exitosamente",
                };
            }

            return {
                success: false,
                data: [],
                message: "No se pudieron obtener los tipos de negocio",
            };
        } catch (error) {
            console.error("Error in getAll typeBusiness service:", error);
            return {
                success: false,
                data: [],
                message: "Error en la conexión con el servidor",
            };
        }
    },

    // Crear tipo de negocio
    create: async (payload) => {
        try {
            const response = await http.post("/v1/type-businesses", payload);

            if (response.requestCode === 201) {
                return {
                    success: true,
                    data: response.data,
                    message: "Tipo de negocio creado exitosamente",
                };
            }

            return {
                success: false,
                message:
                    response.message || "No se pudo crear el tipo de negocio",
            };
        } catch (error) {
            console.error("Error in create typeBusiness service:", error);
            return {
                success: false,
                message: "Error en la conexión con el servidor",
            };
        }
    },

    // Actualizar tipo de negocio
    update: async (id, payload) => {
        try {
            const response = await http.put(
                `/v1/type-businesses/${id}`,
                payload
            );

            if (response.requestCode === 200) {
                return {
                    success: true,
                    data: response.data,
                    message: "Tipo de negocio actualizado exitosamente",
                };
            }

            return {
                success: false,
                message:
                    response.message ||
                    "No se pudo actualizar el tipo de negocio",
            };
        } catch (error) {
            console.error("Error in update typeBusiness service:", error);
            return {
                success: false,
                message: "Error en la conexión con el servidor",
            };
        }
    },

    // Eliminar tipo de negocio
    delete: async (id) => {
        try {
            const response = await http.delete(`/v1/type-businesses/${id}`);

            if (response.requestCode === 200 || response.requestCode === 204) {
                return {
                    success: true,
                    message: "Tipo de negocio eliminado exitosamente",
                };
            }

            return {
                success: false,
                message:
                    response.message ||
                    "No se pudo eliminar el tipo de negocio",
            };
        } catch (error) {
            console.error("Error in delete typeBusiness service:", error);
            return {
                success: false,
                message: "Error en la conexión con el servidor",
            };
        }
    },
};
